import { format, parse } from "date-fns";

export const getCurrentTime12 = () => {
    return format(new Date(), "h:mm a");
};

export const getCurrentTime24 = () => {
    return format(new Date(), "HH:mm");
};

export const convertTo12Hour = (timeStr) => {
    if (!timeStr) return "";
    try {
        const date = parse(timeStr, "HH:mm", new Date());
        if (isNaN(date)) {
            // Try parsing with seconds if simple HH:mm failed
            const dateWithSeconds = parse(timeStr, "HH:mm:ss", new Date());
            if (!isNaN(dateWithSeconds)) {
                return format(dateWithSeconds, "h:mm a");
            }
            return timeStr; // Return original if parsing fails
        }
        return format(date, "h:mm a");
    } catch (e) {
        return timeStr;
    }
};

export const convertTo24Hour = (timeStr) => {
    if (!timeStr) return "";
    try {
        const date = parse(timeStr, "h:mm a", new Date());
        if (isNaN(date)) return timeStr;
        return format(date, "HH:mm");
    } catch (e) {
        return timeStr;
    }
};

export const sumTimeDurations = (times) => {
    let totalSeconds = 0;
    times.forEach(t => {
        if (!t) return;
        const parts = t.split(":").map(Number);
        const h = parts[0] || 0;
        const m = parts[1] || 0;
        const s = parts[2] || 0;
        totalSeconds += h * 3600 + m * 60 + s;
    });
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    return `${hours.toString().padStart(2, "0")}:${minutes.toString().padStart(2, "0")}`;
};
